export const BREAKPOINTS = {
  values: {
    xs: 576,
    sm: 768,
    md: 1012,
    lg: 1172,
    xl: 1364,
    HD: 1504,
    WXGAPlus: 1600,
  },
};

export const COLOR_PURPLE = '#AF52DE';

export const COLOR_FREEMIUM = '#5856D6';
